const headers = {
  name: "Bank Reconcilliation",
  pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
  ],
  navigate: {
    tabs: [
      {
        name: "Bank Reconcilliation",
        path: "",
      }
    ],
  },
};

export default headers;
